import axios from "axios";
import { getToken } from "../../helpers/helpers"; // Importamos el token almacenado en el local storage

// se definen las cabecer por defecto
const defaultHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

// se crea una constante de respuesta que recibe el metodo de la peticion, la ruta, y los datos para hacer las diferentes peticiones con axxios
export const request = async (
  methodOrConfig,
  url,
  payload = {},
  customHeaders = null
) => {
  let method, actualUrl, actualPayload;

  if (typeof methodOrConfig === 'object' && methodOrConfig !== null) {
    // Object config syntax: request({ url, method, data })
    method = methodOrConfig.method;
    actualUrl = methodOrConfig.url;
    actualPayload = methodOrConfig.data !== undefined ? methodOrConfig.data : {};
  } else {
    // Positional syntax: request('get', '/url', data)
    method = methodOrConfig;
    actualUrl = url;
    actualPayload = payload;
  }

  axios.defaults.headers.common.jwt_token = getToken(); //Asiganamos el token a la cabcera de axxios para hacer la peticion

  const isFormData = actualPayload instanceof FormData;
  const headers = customHeaders
    ? { ...customHeaders }
    : isFormData
      ? {} // dejar que el navegador ponga multipart/form-data con boundary
      : { ...defaultHeaders };

  const options = {
    method,
    url: actualUrl,
    headers,
    data: isFormData ? actualPayload : JSON.stringify(actualPayload),
  };
  const response = await axios({ ...options }); //Peticion se realiza a axxios
  return response;
};

